import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { fetchGallery, generateTimePoints } from "../services/galleryService";
import { Gallery, TimePoint } from "../types";
import GalleryComponent from "./Gallery";
import "../styles/EventGallery.css";
import "../styles/Modal.css";
import "../styles/LanguageSelector.css";
import { Language, orderPageTranslations } from "../translations";

const MaterialsGalleryPage: React.FC = () => {
  const { galleryId } = useParams<{ galleryId: string }>();
  const [gallery, setGallery] = useState<Gallery | null>(null);
  const [timePoints, setTimePoints] = useState<TimePoint[]>([]);
  const [showFullDate, setShowFullDate] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [language, setLanguage] = useState<Language>("en");

  const translations = orderPageTranslations[language];

  // Load order data and photos
  useEffect(() => {
    if (!galleryId) return;

    const loadData = async () => {
      setIsLoading(true);

      try {
        // Fetch photos for the order
        const gallery = await fetchGallery(galleryId);
        if (gallery) {
          const orderPhotos = gallery.photos;

          const generatedTimePoints = generateTimePoints(orderPhotos);
          setTimePoints(generatedTimePoints);

          // Check if photos span multiple days
          if (orderPhotos.length > 1) {
            const firstDay = new Date(orderPhotos[0].takenAt).toDateString();
            const lastDay = new Date(
              orderPhotos[orderPhotos.length - 1].takenAt,
            ).toDateString();
            setShowFullDate(firstDay !== lastDay);
          }

          setGallery(gallery);
          setLanguage(gallery.defaultLanguage);
        }
        console.log("Gallery data:", gallery);
      } catch (error) {
        console.error("Error loading gallery data:", error);
      } finally {
        setIsLoading(false);
      }
    };

    // Call the loadData function
    loadData();
  }, [galleryId]);

  if (isLoading) {
    return <div className="loading">{translations.loadingText}</div>;
  } else if (!gallery) {
    return <div></div>;
  }

  const { photos } = gallery;
  const { title = translations.introTitle || "" } =
    gallery.i18n[language] ?? {};

  return (
    <div className="event-gallery-page">
      <header className="gallery-header">
        <h1>{title}</h1>
      </header>

      <GalleryComponent
        photos={photos}
        timePoints={timePoints}
        isLoading={isLoading}
        showFullDate={showFullDate}
        showDownloadButton={true}
        showTimeline={false}
        language={language}
      />
    </div>
  );
};

export default MaterialsGalleryPage;
